/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::622b66f09f9810e3f6fbdd627d1ccd29>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "PageLiveDoc".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for Live Document content type.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const PageLiveDocIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M13.5 3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h4.5V15H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v4.5h-1.5zM12 6H4V4.5h8zM9 9.5H4V8h5z" clip-rule="evenodd"/><path fill="currentcolor" d="m8.59 12.207 3.093-4.488c.314-.456 1.026-.14.898.4l-.481 2.014a.25.25 0 0 0 .243.308h2.16a.5.5 0 0 1 .412.783l-3.093 4.489c-.315.455-1.027.138-.898-.4l.48-2.014a.25.25 0 0 0-.243-.308h-2.16a.5.5 0 0 1-.412-.784"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
PageLiveDocIcon.displayName = 'PageLiveDocIcon';
var _default = exports.default = PageLiveDocIcon;